// Re-export the new Axios-based API service
export * from './api-axios';

// Also export the old types for backward compatibility
export type {
  PaginatedResponse,
  Category,
  ShopProfile,
  Supplier,
  Item,
  ItemImage,
  StockMovement,
  PriceHistory,
  Customer,
  ExchangeItem,
  InvoiceItem,
  Invoice,
  Payment,
  AdvancePayment,
  CustomerPawnProfile,
  PawnItem,
  PawnPayment,
  PawnLoan,
} from './api-axios';

// Export the singleton instance
export { apiService } from './api-axios';